import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { ExperimentalTooltipEl } from "common/components/tooltip";
import { ContextPanelEl } from "common/widgets/context-panel";
import { ButtonEl } from "common/components/button";
import { DropMenuEl, ExperimentalDropMenuEl } from "common/components/drop-menu";
import { Directions, PositioningStrategy } from "common/components/drop-menu/types";
import { InputEl } from "common/components/input";
import { ItemsMenuEl } from "common/components/items-menu";
import { Placement } from "common/components/tooltip/types";
import { ButtonTheme } from "common/components/button/constants";
import { MarkdownEl } from "../markdown";
const Label = ({
  includeLeftIcon,
  includeRightIcon,
  hasSelectedLabel,
  isOverride,
  selectLabel,
  selectLabelTitle,
  leftIcon,
  rightIcon,
  hasSlot
}) => {
  const hasButtonSuffixSlot = hasSlot;
  return /* @__PURE__ */ jsx("div", {
    sel: ".select-label-wrapper",
    attrs: { title: selectLabelTitle }
  }, leftIcon && includeLeftIcon ? /* @__PURE__ */ jsx(SvgIconEl, {
    sel: ".left-icon",
    attrs: {
      elref: `leftIcon`,
      icon: leftIcon
    },
    class: { "select-has-label": hasSelectedLabel }
  }) : null, hasSelectedLabel && (isOverride ? /* @__PURE__ */ jsx(MarkdownEl, {
    sel: ".select-label",
    attrs: { text: selectLabel, elref: `label`, inline: true }
  }) : /* @__PURE__ */ jsx("div", {
    sel: ".select-label",
    attrs: { elref: `label` }
  }, selectLabel)), hasButtonSuffixSlot ? /* @__PURE__ */ jsx("slot", {
    attrs: { name: `button-suffix` }
  }) : null, rightIcon && includeRightIcon ? /* @__PURE__ */ jsx(SvgIconEl, {
    sel: ".right-icon",
    attrs: {
      elref: `rightIcon`,
      icon: rightIcon
    },
    class: { "select-has-label": hasSelectedLabel }
  }) : null);
};
export function SelectTriggerButton({ selectCmp }) {
  const hasTriggerSlot = selectCmp.helpers.hasSlot(`trigger`);
  const { contextPanelTransform, isOpen } = selectCmp.state;
  const showHoverContextPanel = contextPanelTransform && !hasTriggerSlot;
  const theme = selectCmp.helpers.getTriggerButtonTheme();
  const hasSelectedLabel = selectCmp.helpers.hasSelectedLabel();
  const selectLabel = selectCmp.helpers.selectedLabel();
  const selectLabelTitle = selectCmp.helpers.getTitle();
  const { leftIcon, rightIcon } = selectCmp.helpers.getIcon();
  const hasSlot = selectCmp.helpers.hasSlot(`button-suffix`);
  return /* @__PURE__ */ jsx("div", {
    sel: ".select-trigger",
    attrs: {
      elref: `trigger`
    },
    class: {
      "has-trigger-slot": hasTriggerSlot
    },
    on: {
      click: selectCmp.attr(`disabled`) || selectCmp.attr(`readonly`) ? null : () => selectCmp.setDropMenuIsOpen(!isOpen),
      mouseenter: showHoverContextPanel && selectCmp.helpers.handleTriggerMouseEnter,
      mouseleave: showHoverContextPanel && selectCmp.helpers.handleTriggerMouseLeave
    }
  }, selectCmp.helpers.isButtonSelect() ? /* @__PURE__ */ jsx(ButtonEl, {
    class: {
      truncated: !selectCmp.attr(`no-button-truncate`)
    },
    attrs: {
      theme,
      size: selectCmp.attr(`size`),
      disabled: selectCmp.attr(`disabled`),
      readonly: selectCmp.attr(`readonly`),
      layout: selectCmp.attr(`layout`),
      "not-focusable": hasTriggerSlot,
      pressed: isOpen,
      ...leftIcon ? { icon: leftIcon } : {},
      "no-rounded-corners": selectCmp.attr(`no-rounded-corners`),
      "experimental-positioning": selectCmp.attr(`experimental-positioning`)
    },
    on: {
      focus: !hasTriggerSlot ? selectCmp.handleFocus : null,
      blur: !hasTriggerSlot ? selectCmp.handleBlur : null
    }
  }, !selectCmp.attr(`icon-only`) || selectCmp.attr(`show-icon-only-down-caret`) ? /* @__PURE__ */ jsx(Label, {
    includeLeftIcon: false,
    includeRightIcon: selectCmp.helpers.shouldShowRightIcon(),
    hasSelectedLabel,
    isOverride: selectCmp.attr(`label`) !== null,
    selectLabel,
    selectLabelTitle,
    leftIcon,
    rightIcon,
    hasSlot
  }) : null) : hasTriggerSlot ? /* @__PURE__ */ jsx("slot", {
    attrs: { name: `trigger` }
  }) : /* @__PURE__ */ jsx(Label, {
    includeLeftIcon: true,
    includeRightIcon: selectCmp.helpers.shouldShowRightIcon(),
    hasSelectedLabel,
    isOverride: selectCmp.attr(`label`) !== null,
    selectLabel,
    selectLabelTitle,
    leftIcon,
    rightIcon,
    hasSlot
  }));
}
const DropdownBody = ({ selectCmp }) => {
  const { searchFilter, sectionsFromInputFn, dropdownBodyRenderer } = selectCmp.state;
  const hasBodySlot = selectCmp.helpers.hasSlot(`body`);
  const isSearchable = selectCmp.helpers.isSearchable();
  const menuWidthStyle = selectCmp.helpers.getDropMenuWidthStyle();
  const menuHeightStyle = selectCmp.helpers.getDropMenuHeightStyle();
  if (dropdownBodyRenderer) {
    return dropdownBodyRenderer();
  }
  if (hasBodySlot) {
    return /* @__PURE__ */ jsx("slot", {
      attrs: { name: `body` }
    });
  }
  return /* @__PURE__ */ jsx(null, null, selectCmp.attr(`header-title`) ? /* @__PURE__ */ jsx("div", {
    sel: ".header-title",
    style: menuWidthStyle
  }, selectCmp.attr(`back-button`) ? /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".back-button",
    attrs: { theme: ButtonTheme.Tertiary, icon: `arrow-left`, title: `Back (\u21E6 Left Arrow)` },
    on: { click: selectCmp.helpers.handleBackClick }
  }) : null, /* @__PURE__ */ jsx("div", {
    sel: ".title-text"
  }, selectCmp.attr(`header-title`))) : null, isSearchable ? /* @__PURE__ */ jsx(InputEl, {
    key: selectCmp.attr(`header-title`),
    style: menuWidthStyle,
    attrs: {
      "hide-focus-styling": selectCmp.attr(`hide-input-focus-styling`),
      elref: `searchInput`,
      icon: `search`,
      placeholder: selectCmp.attr(`search-placeholder`),
      "show-clear": true,
      tabindex: 0
    },
    props: { value: searchFilter },
    on: {
      clear: () => selectCmp.helpers.handleSearchInput(``),
      input: (ev) => selectCmp.helpers.handleSearchInput(ev.target.value)
    },
    hook: {
      insert: selectCmp.helpers.handleSearchInputInsert,
      destroy: () => selectCmp.focus()
    }
  }) : null, /* @__PURE__ */ jsx(ItemsMenuEl, {
    key: selectCmp.attr(`header-title`),
    style: {
      ...menuWidthStyle,
      ...menuHeightStyle
    },
    attrs: {
      multiple: selectCmp.attr(`multiple`),
      "show-select-all": selectCmp.attr(`show-select-all`),
      "search-filter": searchFilter,
      "empty-message": selectCmp.attr(`empty-message`),
      "align-all-text": selectCmp.attr(`align-all-text`),
      "experimental-positioning": selectCmp.attr(`experimental-positioning`),
      "disable-first-item-padding": selectCmp.attr(`disable-first-item-padding`),
      "start-focus-on-selected": selectCmp.attr(`start-focus-on-selected`)
    },
    props: {
      sections: selectCmp.helpers.getItemsMenuSections(),
      sectionsFromInputFn,
      keydownProxyEl: selectCmp,
      contextPanelTransform: selectCmp.helpers.itemContextPanelTransform(),
      contextPanelPositionParentElement: selectCmp.contextPanelPositionParentElement
    },
    on: {
      clickItem: selectCmp.helpers.handleClickItem,
      focusItem: selectCmp.helpers.handleFocusItem,
      selectAll: selectCmp.helpers.handleSelectAll
    }
  }, selectCmp.helpers.hasSlot(`context-panel-content`) && /* @__PURE__ */ jsx("slot", {
    attrs: { name: `context-panel-content`, slot: `context-panel-content` }
  })));
};
export function template() {
  const { contextPanelTransform, isOpen, tooltipData } = this.state;
  const hasTriggerSlot = this.helpers.hasSlot(`trigger`);
  const hasFooterSlot = this.helpers.hasSlot(`footer`);
  const tooltip = this.helpers.getTooltip();
  const showHoverContextPanel = contextPanelTransform && !hasTriggerSlot;
  const DropdownEl = this.attr(`experimental-positioning`) ? ExperimentalDropMenuEl : DropMenuEl;
  return /* @__PURE__ */ jsx("div", {
    sel: ".select-container",
    class: { "has-trigger-slot": hasTriggerSlot }
  }, !isOpen && tooltip && /* @__PURE__ */ jsx(ExperimentalTooltipEl, {
    attrs: {
      placement: Placement.Top,
      "delay-in": 10,
      "delay-out": 10,
      ...tooltip
    },
    props: { parentEl: this }
  }), !isOpen && showHoverContextPanel && tooltipData ? /* @__PURE__ */ jsx(ContextPanelEl, {
    attrs: {
      elref: `hoverContextPanel`,
      "tooltip-data": tooltipData,
      placement: tooltipData.placement || Directions.Down,
      "position-strategy": PositioningStrategy.Fixed
    },
    on: {
      hoverIn: this.helpers.handleContextPanelHoverIn,
      hoverOut: this.helpers.handleContextPanelHoverOut
    }
  }) : null, /* @__PURE__ */ jsx(SelectTriggerButton, {
    selectCmp: this
  }), isOpen ? (() => {
    return /* @__PURE__ */ jsx("div", {
      sel: ".select-drop-menu"
    }, /* @__PURE__ */ jsx(DropdownEl, {
      attrs: {
        "data-force-visibility": this.attr(`force-visibility`),
        elRef: `selectDropMenu`,
        open: isOpen,
        direction: this.attr(`menu-alignment`),
        "experimental-positioning": this.attr(`experimental-positioning`),
        "prevent-close": this.attr(`prevent-close`),
        "prevent-close-selectors": [
          `#chmln-dom`,
          `.create-custom-button`
        ]
      },
      on: { change: (ev) => this.helpers.handleDropMenuChange(ev) },
      hook: { insert: this.helpers.handleDropMenuInsert },
      props: { positionParent: this }
    }, /* @__PURE__ */ jsx(DropdownBody, {
      selectCmp: this
    }), hasFooterSlot ? /* @__PURE__ */ jsx("div", {
      sel: ".select-footer"
    }, /* @__PURE__ */ jsx("slot", {
      attrs: { name: `footer` }
    })) : null));
  })() : null);
}
